import React from "react";

export default function Location() {
  return (
    <div className="location">
      <form>
        <button className="currentLocation" type="submit">
          Current Location
        </button>
      </form>
      <p>
        <a href="https://github.com/panifarz/weather-react" target="blank">
          {" "}
          Open-source code
        </a>{" "}
        by Pani Farzadmanesh from <a href="github.com">Github</a>{" "}
      </p>
    </div>
  );
}
